export enum CredentialInputKeys {
    APIKey = "APIKey",
    APIKeyID = "APIKeyID",
}

export type SindriCredentials = {
    APIKey: string
    APIKeyID: string
}
